import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';

// Use the bundled monaco-editor (0.45.x) so workers from vite-plugin-monaco-editor match.
// Without this, @monaco-editor/loader pulls a newer CDN build and init can hang forever.
loader.config({ monaco });

/**
 * Guard against broken Monaco worker URLs (relative "undefined" under /studio/flows/…).
 * vite-plugin-monaco-editor normally sets MonacoEnvironment; this only fills gaps.
 */
if (typeof window !== 'undefined') {
  const existing = window.MonacoEnvironment || {};
  window.MonacoEnvironment = {
    ...existing,
    getWorkerUrl(moduleId, label) {
      if (typeof existing.getWorkerUrl === 'function') {
        const url = existing.getWorkerUrl(moduleId, label);
        if (url && String(url) !== 'undefined') return url;
      }
      // Prefer plugin-emitted workers under /monacoeditorwork/
      const map = {
        json: '/monacoeditorwork/json.worker.bundle.js',
        typescript: '/monacoeditorwork/ts.worker.bundle.js',
        javascript: '/monacoeditorwork/ts.worker.bundle.js',
        css: '/monacoeditorwork/css.worker.bundle.js',
        html: '/monacoeditorwork/html.worker.bundle.js',
        editorWorkerService: '/monacoeditorwork/editor.worker.bundle.js',
      };
      return map[label] || '/monacoeditorwork/editor.worker.bundle.js';
    },
  };
}
